/** Mesma regra de ai_gateway.cost_micros: micro-dólares, arredondado para cima; preço por milhão de tokens. */
export function costMicros(promptTokens: number, completionTokens: number, inputPerMtok: number | null, outputPerMtok: number | null): number {
  return Math.ceil((promptTokens * (inputPerMtok ?? 0) + completionTokens * (outputPerMtok ?? 0)) / 1_000_000);
}

/** "US$ 1,23" a partir de micro-dólares (tela). */
export function formatUsd(micros: number | null | undefined, digits = 2): string {
  const v = (micros ?? 0) / 1_000_000;
  return `US$ ${v.toLocaleString("pt-BR", { minimumFractionDigits: digits, maximumFractionDigits: Math.max(digits, 2) })}`;
}
